import axios from 'axios'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  session: getSavedState('auth.session'),
  token: getSavedState('auth.token'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
  },
  SET_SESSION(state, newValue) {
    state.session = newValue
    saveState('auth.session', newValue)
  },
  SET_TOKEN(state, newValue) {
    state.token = newValue
    saveState('auth.token', newValue)
    setDefaultAuthHeaders(state)
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    console.log(state.session);
    return state.session
  },
}


export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  async logIn({ commit, dispatch, getters }, { username, password } = {}) {

    try{

      const response = await axios.post('auth/login', { username, password })

      if (getters.loggedIn) return dispatch('validate')

      const token = response.data.result
      commit('SET_SESSION', true)
      commit('SET_TOKEN', token)
      return { status: true, message: response.message }
    }
    catch (e){
      console.log(e)
      commit('SET_SESSION', false)
      commit('SET_TOKEN', null)
      commit('SET_CURRENT_USER', null)
      return { status: false, message: 'Invalid username or password!' }
    }
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_SESSION', false)
    commit('SET_TOKEN', null)
    commit('SET_CURRENT_USER', null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the sandbox.
  async validate({ commit, state }) {

    if (!state.session) return Promise.resolve(null)

    try{
      // const token = state.token;

      const response = await axios.post('https://api.99gift.in/admin/v1/auth/session', {},{})

      const user = response.data.result
      commit('SET_CURRENT_USER', user)
      return user;
    }
    catch (e){
      console.log("ERROR")
      commit('SET_SESSION', false)
      commit('SET_TOKEN', null)
      commit('SET_CURRENT_USER', null)
      return null
    }
  },

  // reset password
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/reset', { email})
      .then((response) => {
        const message = response.data
        return message
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  window.localStorage.setItem('token', state.token)
  axios.defaults.headers.common['X-Token'] = state.token
    ? state.token
    : ''
}
